module.exports = __webpack_public_path__ + "img/bg-login-page.71fd8223.svg";